import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FooterProps } from './types';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import './Footer.scss';

export const Footer: React.FC<FooterProps> = ({
  page,
  children,
  onBack,
  onNext,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(`/onboarding/${page - 1}`);
    }
  };
  return (
    <footer className="d-flex">
      {children}
      <div
        className={`d-flex ${
          page === 0 ? 'justify-content-end' : 'justify-content-between'
        }`}
      >
        <Button
          variant="outlined"
          hidden={page === 0}
          startIcon={<ArrowBack />}
          onClick={handleBack}
        >
          {t('btn_back')}
        </Button>

        <Button variant="contained" type="submit" onClick={onNext}>
          {page === 2 ? t('btn_finish') : `${t('btn_next')} ->`}
        </Button>
      </div>
    </footer>
  );
};
